<template>
  <div class="remoteInstructions">
    <div class="icon" title="Orientações" @click="modal.show = true">?</div>
    <Modal class="modal" :modal="modal">
      <div class="label">Resolveremos seu problema de TI em poucos passos</div>
      <div class="pass row column-s">
        <div class="grid-4 grid-12-s column align-center">
          <img src="../assets/img/solicite-01.png" />
          <span>
            Clique no botão
            <br />
            <b>SOLICITAR ATENDIMENTO</b>
            <br />e escolha o canal desejado
          </span>
        </div>
        <div class="grid-4 grid-12-s column align-center">
          <img src="../assets/img/robot.png" />
          <span>
            Descreva seu problema para <b>{{ user.nome_bot_km }}</b
            >, <br />
            nossa assistente virtual. <br />Se necessário, ela te conectará a um
            de nossos especialistas.
          </span>
        </div>
        <div class="grid-4 grid-12-s column align-center">
          <img src="../assets/img/avalie-01.png" />
          <span>Avalie o nosso atendimnento em seu e-mail</span>
        </div>
      </div>
      <div class="orientation row wrap justify-end justify-center-s">
        Você pode voltar a conferir estas orientações no ícone
        <img src="../assets/img/interrogacao-preto-01.png" /> no canto superior
        direito
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/Modal.vue";

export default {
  name: "remoteInstructions",
  components: { Modal },
  props: {},
  data() {
    return {
      modal: {},
    };
  },
  methods: {},
  mounted() {
    this.modal = { title: "Olá " + this.user.nome, show: true };
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.remoteInstructions {
  .modal {
    @media (min-width: 850px) {
      position: absolute;
      left: 50%;
    }
  }
  .orientation {
    font-size: 12px;
    text-align: right;
    padding: 15px;
    padding-top: 0px;
    img {
      width: 15px;
      height: 15px;
      margin: 0px 5px;
    }
  }
  .icon {
    border-radius: 50%;
    color: $white;
    border: 1px solid $white;
    width: 24px;
    height: 24px;
    font-size: 15px;
    line-height: 25px;
    text-align: center;
    margin-right: 25px;
    margin-top: 5px;
    cursor: pointer;
  }
  .label {
    padding: 0px 32px;
  }
  .pass {
    @media (min-width: 850px) {
      min-width: 650px;
    }
    padding: 20px 15px;
    font-size: 13px;
    text-align: center;
    color: $gray-3;
    img {
      width: 100px;
      margin: 15px;
    }
    span {
      margin-bottom: 30px;
    }
  }
}
</style>
